(function () {
    async function fetchInstitutions() {
      const query = `
        {
          metaobjects(type: "institution", first: 50) {
            edges {
              node {
                handle
                fields {
                  key
                  value
                }
              }
            }
          }
        }
      `;

      const res = await fetch(
        `https://${window.SHUK_SHOP_DOMAIN}/api/2024-01/graphql.json`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': window.SHUK_STOREFRONT_TOKEN,
          },
          body: JSON.stringify({ query })
        }
      );

      const data = await res.json();
      console.log('Raw metaobjects response:', JSON.stringify(data));

      return data?.data?.metaobjects?.edges?.map(({ node }) => {
        const fields = {};
        node.fields.forEach(f => fields[f.key] = f.value);
        return {
          id: node.handle,
          name: fields.name || '',
          kind: fields.kind || 'org'
        };
      }) || [];
    }
  
    let accountType = null;
    let selectedInstitution = null;
    let selectedInstitutions = [];
    let independentAllocations = [];
    let selectedSchools = [{ id: '', name: '', tuitionNumber: '' }];
    let openPickerIndex = null;
  
    const step1 = document.getElementById('step-1');
    const step2 = document.getElementById('step-2');
    const step3 = document.getElementById('step-3');
    const step4 = document.getElementById('step-4');
    const shukPage = document.querySelector('.shuk-page');
  
    const cardIndependent = document.getElementById('card-independent');
    const cardTuition     = document.getElementById('card-tuition');
    const radioIndep      = document.getElementById('radio-independent');
    const radioTuition    = document.getElementById('radio-tuition');
    const step1Btn        = document.getElementById('step1-continue');
  
    const roleLabel       = document.getElementById('role-label');
    const step2Heading    = document.getElementById('step2-heading');
    const step2Subtext    = document.getElementById('step2-subtext');
    const institutionList = document.getElementById('institution-list');
    const institutionSummary = document.getElementById('institution-summary');
    const orgSubmitConfirm = document.getElementById('org-submit-confirm');
    const searchInput     = document.getElementById('institution-search');
    const familyCodeWrap  = document.getElementById('family-code-wrap');
    const familyCodeInput = document.getElementById('family-code-input');
    const step2Btn        = document.getElementById('step2-continue');

    const pickerWrap          = document.getElementById('picker-wrap');
    const schoolCardsContainer = document.getElementById('school-cards-container');
    const addSchoolBtn        = document.getElementById('add-school-btn');
  
    const addressBlock  = document.getElementById('address-block');
    const errorsEl      = document.getElementById('shuk-form-errors');
    const submitBtn     = document.getElementById('submit-btn');

    let INSTITUTIONS = [];
  
    function show(el) { el.classList.remove('shuk-step--hidden'); }
    function hide(el) { el.classList.add('shuk-step--hidden'); }
    function setWide(isWide) { shukPage.classList.toggle('shuk-page--wide', isWide); }
  
    // ── Step 1 ───────────────────────────────────────────────────────────
    function selectType(type) {
      accountType = type;
      cardIndependent.classList.toggle('selected', type === 'independent');
      cardTuition.classList.toggle('selected', type === 'tuition');
      radioIndep.classList.toggle('selected', type === 'independent');
      radioTuition.classList.toggle('selected', type === 'tuition');
      step1Btn.disabled = false;
      step1Btn.classList.remove('shuk-btn--disabled');
    }
  
    // ── Step 2 ───────────────────────────────────────────────────────────
    function setupStep2() {
      step2Btn.disabled = true;
      step2Btn.classList.add('shuk-btn--disabled');
      step2.classList.add('shuk-step--picker-grid');

      if (accountType === 'tuition') {
        show(roleLabel);
        step2Heading.innerHTML = 'Which school do you <span class="shuk-heading-accent">support</span>?';
        step2Subtext.textContent = "We'll apply your shopping credits to your tuition bill.";
        hide(familyCodeWrap);
        hide(pickerWrap);
        show(schoolCardsContainer);
        selectedSchools = [{ id: '', name: '', tuitionNumber: '' }];
        openPickerIndex = null;
        renderSchoolCards();
        updateStep2Button();
      } else {
        hide(roleLabel);
        step2Heading.innerHTML = 'Who would you like to <span class="shuk-heading-accent">support</span>?';
        step2Subtext.textContent = 'Select one or more causes to support.';
        show(familyCodeWrap);
        show(pickerWrap);
        hide(schoolCardsContainer);
        addSchoolBtn.classList.remove('visible');
        selectedInstitution = null;
        selectedInstitutions = [];
        independentAllocations = [];
        searchInput.value = '';
        renderList(getBaseList());
        updateIndependentSummary();
      }
    }

    // ── Step 2 (tuition): multi-school cards ──────────────────────────────
    function getSchoolList() {
      return INSTITUTIONS.filter(i => i.kind === 'school');
    }

    function isCardComplete(s) {
      return s.id !== '' && s.tuitionNumber.trim().length > 0;
    }

    function updateStep2Button() {
      const enabled =
        accountType === 'tuition'
          ? selectedSchools.length > 0 && selectedSchools.every(isCardComplete)
          : selectedInstitutions.length > 0;
      step2Btn.disabled = !enabled;
      step2Btn.classList.toggle('shuk-btn--disabled', !enabled);
    }

    function updateAddSchoolBtn() {
      const last = selectedSchools[selectedSchools.length - 1];
      const showAdd =
        !!last && last.id !== '' && last.tuitionNumber.trim().length > 0;
      addSchoolBtn.classList.toggle('visible', showAdd);
    }

    function buildInlinePicker(index) {
      const wrap = document.createElement('div');
      wrap.style.padding = '0 16px 16px';

      const search = document.createElement('input');
      search.type = 'text';
      search.className = 'shuk-search shuk-pill-search';
      search.placeholder = 'Search schools…';
      search.autocomplete = 'off';

      const grid = document.createElement('div');
      grid.className = 'shuk-inst-grid';

      const takenIds = new Set(
        selectedSchools
          .filter((_, i) => i !== index)
          .map(s => s.id)
          .filter(Boolean),
      );
      const available = getSchoolList().filter(i => !takenIds.has(i.id));

      function renderPickerGrid(items) {
        grid.innerHTML = '';
        if (items.length === 0) {
          grid.innerHTML = '<div style="padding:12px;color:#888">No matches found.</div>';
          return;
        }
        items.forEach(item => {
          const isSel = selectedSchools[index].id === item.id;
          const card = document.createElement('div');
          card.className = 'shuk-inst-card' + (isSel ? ' selected' : '');

          const monogram = document.createElement('div');
          monogram.className = 'shuk-inst-monogram';
          monogram.textContent = getInitials(item.name);
          card.appendChild(monogram);

          const nameEl = document.createElement('div');
          nameEl.className = 'shuk-inst-card__name';
          nameEl.textContent = item.name;
          card.appendChild(nameEl);

          const kindEl = document.createElement('div');
          kindEl.className = 'shuk-inst-card__kind';
          kindEl.textContent = 'School';
          card.appendChild(kindEl);

          if (isSel) {
            const check = document.createElement('span');
            check.className = 'shuk-check';
            check.textContent = '✓';
            card.appendChild(check);
          }

          card.addEventListener('click', () => {
            selectedSchools[index].id = item.id;
            selectedSchools[index].name = item.name;
            openPickerIndex = null;
            renderSchoolCards();
            updateStep2Button();
          });
          grid.appendChild(card);
        });
      }

      search.addEventListener('click', e => e.stopPropagation());
      search.addEventListener('input', () => {
        const q = search.value.trim().toLowerCase();
        renderPickerGrid(q ? available.filter(i => i.name.toLowerCase().includes(q)) : available);
      });

      renderPickerGrid(available);
      wrap.appendChild(search);
      wrap.appendChild(grid);
      return wrap;
    }

    function renderSchoolCards() {
      schoolCardsContainer.innerHTML = '';

      selectedSchools.forEach((school, index) => {
        // An unselected slot shows its grid immediately — no "Select a
        // school" placeholder to click through first, and no boxed card
        // around it either, matching the independent picker's flush grid.
        // Once a school is picked, it collapses to a compact boxed summary
        // + tuition number field (tap it again to reopen and change the pick).
        const hasHeaderRow = !!school.id || selectedSchools.length > 1;

        const card = document.createElement('div');
        card.className = hasHeaderRow ? 'shuk-school-card' : 'shuk-school-card--plain';

        const showGrid = !school.id || openPickerIndex === index;

        if (school.id) {
          const row = document.createElement('div');
          row.className = 'shuk-school-card__picker-row';

          const nameSpan = document.createElement('span');
          nameSpan.className = 'shuk-school-card__name';
          nameSpan.innerHTML = '<span class="shuk-check">✓</span> ' + school.name;
          row.appendChild(nameSpan);

          if (selectedSchools.length > 1) {
            const removeBtn = document.createElement('span');
            removeBtn.className = 'shuk-school-card__remove';
            removeBtn.textContent = '×';
            removeBtn.addEventListener('click', e => {
              e.stopPropagation();
              selectedSchools.splice(index, 1);
              if (openPickerIndex === index) openPickerIndex = null;
              else if (openPickerIndex > index) openPickerIndex -= 1;
              renderSchoolCards();
              updateStep2Button();
            });
            row.appendChild(removeBtn);
          }

          row.addEventListener('click', () => {
            openPickerIndex = openPickerIndex === index ? null : index;
            renderSchoolCards();
          });
          card.appendChild(row);

          const numberWrap = document.createElement('div');
          numberWrap.className = 'shuk-school-card__number-wrap visible';
          const numberInput = document.createElement('input');
          numberInput.type = 'text';
          numberInput.className = 'shuk-school-card__number-input';
          numberInput.placeholder = 'Tuition account number';
          numberInput.value = school.tuitionNumber;
          numberInput.addEventListener('click', e => e.stopPropagation());
          numberInput.addEventListener('keyup', () => {
            selectedSchools[index].tuitionNumber = numberInput.value;
            updateStep2Button();
            updateAddSchoolBtn();
          });
          numberWrap.appendChild(numberInput);
          card.appendChild(numberWrap);
        } else if (selectedSchools.length > 1) {
          // Blank slot, but more than one exists — offer a way to remove it.
          const removeRow = document.createElement('div');
          removeRow.className = 'shuk-school-card__remove-row';
          const removeBtn = document.createElement('span');
          removeBtn.className = 'shuk-school-card__remove';
          removeBtn.textContent = '×';
          removeBtn.addEventListener('click', () => {
            selectedSchools.splice(index, 1);
            if (openPickerIndex === index) openPickerIndex = null;
            else if (openPickerIndex > index) openPickerIndex -= 1;
            renderSchoolCards();
            updateStep2Button();
          });
          removeRow.appendChild(removeBtn);
          card.appendChild(removeRow);
        }

        if (showGrid) {
          const picker = buildInlinePicker(index);
          if (!hasHeaderRow) picker.style.padding = '0';
          card.appendChild(picker);
        }

        schoolCardsContainer.appendChild(card);
      });

      updateAddSchoolBtn();
    }

    function getBaseList() {
      return accountType === 'tuition'
        ? INSTITUTIONS.filter(i => i.kind === 'school')
        : INSTITUTIONS;
    }
  
    // ── Step 2 (independent): multi-select institutions ──────────────────
    function equalSplit(count) {
      if (count <= 0) return [];
      const base = Math.floor(100 / count);
      const arr = new Array(count).fill(base);
      arr[0] += 100 - base * count;
      return arr;
    }

    function isInstitutionSelected(id) {
      return selectedInstitutions.some(i => i.id === id);
    }

    function rebuildIndependentAllocations() {
      const pcts = equalSplit(selectedInstitutions.length);
      independentAllocations = selectedInstitutions.map((inst, i) => {
        const alloc = {
          id: inst.id,
          name: inst.name,
          percentage: pcts[i],
        };
        if (inst.pending) alloc.pending = true;
        return alloc;
      });
    }

    const MAX_INDEPENDENT_CAUSES = 4;
    let causeHintTimer = null;

    function showCauseLimitHint() {
      institutionSummary.textContent = `You can support up to ${MAX_INDEPENDENT_CAUSES} causes.`;
      show(institutionSummary);
      clearTimeout(causeHintTimer);
      causeHintTimer = setTimeout(updateIndependentSummary, 2000);
    }

    function toggleInstitution(item) {
      const idx = selectedInstitutions.findIndex(i => i.id === item.id);
      if (idx === -1) {
        if (selectedInstitutions.length >= MAX_INDEPENDENT_CAUSES) {
          showCauseLimitHint();
          return false;
        }
        selectedInstitutions.push({ id: item.id, name: item.name });
      } else {
        selectedInstitutions.splice(idx, 1);
      }
      selectedInstitution = selectedInstitutions[0] || null;
      rebuildIndependentAllocations();
      return true;
    }

    function updateIndependentSummary() {
      const count = independentAllocations.length;
      if (count === 0) {
        hide(institutionSummary);
        institutionSummary.textContent = '';
        return;
      }
      const noun = count === 1 ? 'cause' : 'causes';
      const pcts = independentAllocations.map(a => a.percentage + '%').join(' / ');
      institutionSummary.textContent = `Supporting ${count} ${noun} — ${pcts}`;
      show(institutionSummary);
    }

    function getInitials(name) {
      const words = String(name)
        .trim()
        .split(/\s+/)
        .map(w => w.replace(/[^A-Za-z]/g, ''))
        .filter(Boolean);
      if (words.length === 0) return '';
      if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
      return (words[0][0] + words[1][0]).toUpperCase();
    }

    function renderList(items) {
      institutionList.innerHTML = '';
      if (items.length === 0) {
        institutionList.innerHTML = '<div style="padding:12px;color:#888">No matches found.</div>';
        return;
      }
      const atLimit = selectedInstitutions.length >= MAX_INDEPENDENT_CAUSES;
      items.forEach(item => {
        const selected = isInstitutionSelected(item.id);
        const card = document.createElement('div');
        let cls = 'shuk-inst-card';
        if (selected) cls += ' selected';
        else if (atLimit) cls += ' shuk-inst-card--limit';
        card.className = cls;

        const monogram = document.createElement('div');
        monogram.className = 'shuk-inst-monogram';
        monogram.textContent = getInitials(item.name);
        card.appendChild(monogram);

        const nameEl = document.createElement('div');
        nameEl.className = 'shuk-inst-card__name';
        nameEl.textContent = item.name;
        card.appendChild(nameEl);

        const kindEl = document.createElement('div');
        kindEl.className = 'shuk-inst-card__kind';
        kindEl.textContent = item.kind === 'school' ? 'School' : 'Organization';
        card.appendChild(kindEl);

        if (selected) {
          const check = document.createElement('span');
          check.className = 'shuk-check';
          check.textContent = '✓';
          card.appendChild(check);
        }

        card.addEventListener('click', () => {
          const changed = toggleInstitution(item);
          renderList(items);
          if (changed) updateIndependentSummary();
          updateStep2Button();
        });
        institutionList.appendChild(card);
      });
    }

    // ── Pending org submission (front-end only) ──────────────────────────
    function slugifyOrg(s) {
      return String(s)
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function showOrgSubmitConfirm(name) {
      if (!orgSubmitConfirm) return;
      orgSubmitConfirm.textContent =
        name + ' submitted — you can finish signing up and start shopping.';
      show(orgSubmitConfirm);
    }

    // Treats a user-submitted org like any chosen cause, flagged pending:true.
    // No approval/credit logic here — that lives in the backend (separate task).
    function addPendingOrg(org) {
      if (!org || !org.name) return false;
      if (accountType !== 'independent') return false;

      const id = 'pending-' + (slugifyOrg(org.name) || String(Date.now()));
      if (!selectedInstitutions.some(i => i.id === id)) {
        if (selectedInstitutions.length >= MAX_INDEPENDENT_CAUSES) {
          showCauseLimitHint();
          return false;
        }
        selectedInstitutions.push({ id, name: org.name, pending: true });
      }

      selectedInstitution = selectedInstitutions[0] || null;
      rebuildIndependentAllocations();
      renderList(getBaseList());
      updateIndependentSummary();
      updateStep2Button();
      showOrgSubmitConfirm(org.name);
      return true;
    }

    // ── Step 3 ───────────────────────────────────────────────────────────
    function setupStep3() {
      hide(addressBlock);
    }
  
    // ── Event listeners (attached after institutions load) ────────────────
    function setupEventListeners() {
      cardIndependent.addEventListener('click', () => selectType('independent'));
      cardTuition.addEventListener('click', () => selectType('tuition'));

      step1Btn.addEventListener('click', () => {
        if (!accountType) return;
        setupStep2();
        setWide(true);
        show(step2); hide(step1);
      });

      addSchoolBtn.addEventListener('click', () => {
        selectedSchools.push({ id: '', name: '', tuitionNumber: '' });
        renderSchoolCards();
        updateStep2Button();
      });

      searchInput.addEventListener('input', () => {
        const q = searchInput.value.trim().toLowerCase();
        const base = getBaseList();
        renderList(q ? base.filter(i => i.name.toLowerCase().includes(q)) : base);
      });

      step2Btn.addEventListener('click', () => {
        if (step2Btn.disabled) return;
        setupStep3();
        show(step3); hide(step2);
      });

      document.getElementById('step2-back').addEventListener('click', () => {
        setWide(false);
        show(step1); hide(step2);
      });

      document.getElementById('step3-back').addEventListener('click', () => {
        show(step2); hide(step3);
      });

    // ── Submit via Storefront API ─────────────────────────────────────────
    submitBtn.addEventListener('click', async () => {
      console.log('Handler fired, token:', window.SHUK_STOREFRONT_TOKEN ? 'present' : 'MISSING');
      hide(errorsEl);
      errorsEl.textContent = '';
  
      const firstName = document.getElementById('field-first-name').value.trim();
      const lastName  = document.getElementById('field-last-name').value.trim();
      const email     = document.getElementById('field-email').value.trim();
      console.log('Submit values:', { firstName, lastName, email });
      const password  = document.getElementById('field-password').value;
  
      if (!firstName || !lastName || !email || !password) {
        errorsEl.textContent = 'Please fill in all required fields.';
        show(errorsEl);
        return;
      }
  
      submitBtn.textContent = 'Creating account…';
      submitBtn.disabled = true;

      const note = JSON.stringify({
        account_type:     accountType,
        institution_id:   selectedInstitution?.id   || '',
        institution_name: selectedInstitution?.name || '',
        family_code:      familyCodeInput.value.trim().toUpperCase(),
      });
  
      const createMutation = `
      mutation customerCreate($input: CustomerCreateInput!) {
        customerCreate(input: $input) {
          customer { id }
          customerUserErrors { field message }
        }
      }
    `;

    try {
      const res = await fetch(`https://${window.SHUK_SHOP_DOMAIN}/api/2024-01/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': window.SHUK_STOREFRONT_TOKEN,
        },
        body: JSON.stringify({
          query: createMutation,
          variables: {
            input: {
              firstName,
              lastName,
              email,
              password,
            }
          }
        })
      });

      const data = await res.json();
      console.log('customerCreate response:', JSON.stringify(data));
      const errors = data?.data?.customerCreate?.customerUserErrors;

      if (errors && errors.length > 0) {
        errorsEl.textContent = errors.map(e => e.message).join(' ');
        show(errorsEl);
        submitBtn.textContent = 'CREATE ACCOUNT';
        submitBtn.disabled = false;
        return;
      }

      // ── Write metafields via backend endpoint ─────────────────────
      const customerId = data?.data?.customerCreate?.customer?.id;

      if (customerId) {
        const allocations = accountType === 'tuition'
          ? selectedSchools.map(s => ({
              id: s.id,
              name: s.name,
              tuitionNumber: s.tuitionNumber
            }))
          : independentAllocations;

        // Fire and forget — do not block redirect
        fetch('DAVID_ENDPOINT_URL/api/customer/metafields', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-internal-token': window.SHUK_INTERNAL_TOKEN,
          },
          body: JSON.stringify({
            customerId,
            metafields: [
              { key: 'account_type',        value: accountType },
              { key: 'charity_id',          value: allocations[0]?.id   || '' },
              { key: 'charity_name',        value: allocations[0]?.name || '' },
              { key: 'family_group_id',     value: familyCodeInput.value.trim().toUpperCase() },
              { key: 'charity_allocations', value: JSON.stringify(allocations) },
            ]
          })
        }).catch(err => console.log('Metafield write error:', err));
      }

      // ── Redirect to Shopify login ─────────────────────────────────
      show(step4); hide(step3);

    } catch (err) {
      console.log('CAUGHT ERROR:', err);
      errorsEl.textContent = 'Something went wrong. Please try again.';
      show(errorsEl);
      submitBtn.textContent = 'CREATE ACCOUNT';
      submitBtn.disabled = false;
    }
  });
    }

    // ── Init: fetch institutions, then wire up the UI ─────────────────────
    async function init() {
      try {
        console.log('Fetching institutions...');
        INSTITUTIONS = await fetchInstitutions();
        console.log('Institutions loaded:', INSTITUTIONS);
      } catch(e) {
        console.log('Failed to fetch institutions:', e);
      }
      setupEventListeners();
    }

    // Expose the pending-org hook for the submit-organization modal.
    window.ShukSignup = window.ShukSignup || {};
    window.ShukSignup.addPendingOrg = addPendingOrg;

    init();

})();